import React, { useEffect, useState } from 'react';
import { StarIcon } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'María Valdivia',
    role: 'Vendedora en Ñuñoa',
    image: 'https://randomuser.me/api/portraits/women/12.jpg',
    quote: 'Filtraron súper bien: pocas visitas, todas con intención real. La carpeta legal lista nos ahorró semanas.'
  }, {
    name: 'Gonzalo Pérez',
    role: 'Vendedor en Las Condes',
    image: 'https://randomuser.me/api/portraits/men/23.jpg',
    quote: 'Tarifa fija clara. Abiertos a canje, mi departamento se movió en todas las redes. Resultado impecable.'
  }, {
    name: 'Carolina Sáez',
    role: 'Vendedora inversión',
    image: 'https://randomuser.me/api/portraits/women/31.jpg',
    quote: 'Me gustó la tasación con 3 fuentes. Precio correcto, negociación profesional y cierre rápido.'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const nextTestimonial = () => setCurrentIndex(i => i === testimonials.length - 1 ? 0 : i + 1);
  const prevTestimonial = () => setCurrentIndex(i => i === 0 ? testimonials.length - 1 : i - 1);
  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => setTouchStart(e.targetTouches[0].clientX);
  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => setTouchEnd(e.targetTouches[0].clientX);
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) nextTestimonial();
    if (touchStart - touchEnd < -75) prevTestimonial();
  };
  useEffect(() => {
    const interval = setInterval(nextTestimonial, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section id="testimonials" className="py-10 sm:py-24 bg-gray-50" data-id="element-234">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-235">
        <div className="text-center" data-id="element-236">
          <h2 className="text-sm font-semibold text-blue-600 tracking-wide uppercase" data-id="element-237">Casos de Éxito</h2>
          <p className="mt-1 text-xl sm:text-3xl font-extrabold text-gray-900" data-id="element-238">Lo que dicen quienes vendieron</p>
          <p className="mt-2 max-w-2xl text-sm sm:text-lg text-gray-500 mx-auto" data-id="element-239">
            Procesos ordenados, menos fricción y resultados concretos.
          </p>
        </div>

        <div className="mt-6 sm:mt-16 relative" data-id="element-240">
          {/* Mobile Carousel */}
          <div className="sm:hidden relative overflow-hidden" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-241">
            <div className="flex transition-transform duration-300 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-242">
              {testimonials.map((t, idx) => <div key={idx} className="w-full flex-shrink-0 px-1" data-id="element-243">
                  <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-100 h-full" data-id="element-244">
                    <div className="flex items-center" data-id="element-245">
                      <img className="h-8 w-8 rounded-full" src={t.image} alt={t.name} loading="lazy" data-id="element-246" />
                      <div className="ml-2" data-id="element-247">
                        <h4 className="text-sm font-medium text-gray-900" data-id="element-248">{t.name}</h4>
                        <p className="text-2xs text-gray-500" data-id="element-249">{t.role}</p>
                      </div>
                    </div>
                    <div className="mt-2 flex" data-id="element-250">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-3 w-3 text-yellow-400" fill="currentColor" data-id="element-251" />)}
                    </div>
                    <p className="mt-2 text-xs text-gray-600 italic" data-id="element-252">"{t.quote}"</p>
                  </div>
                </div>)}
            </div>

            <div className="absolute bottom-0 left-0 right-0 flex justify-center space-x-1 pb-2 pt-1" data-id="element-253">
              {testimonials.map((_, i) => <button key={i} className={`w-1.5 h-1.5 rounded-full ${i === currentIndex ? 'bg-blue-600' : 'bg-gray-300'}`} onClick={() => setCurrentIndex(i)} data-id="element-254" />)}
            </div>
          </div>

          {/* Desktop Grid */}
          <div className="hidden sm:grid sm:grid-cols-1 sm:gap-6 lg:grid-cols-3 lg:gap-8" data-id="element-255">
            {testimonials.map((t, idx) => <div key={idx} className="bg-white rounded-lg shadow-sm p-8 border border-gray-100" data-id="element-256">
                <div className="flex items-center" data-id="element-257">
                  <img className="h-12 w-12 rounded-full" src={t.image} alt={t.name} loading="lazy" data-id="element-258" />
                  <div className="ml-4" data-id="element-259">
                    <h4 className="text-lg font-medium text-gray-900" data-id="element-260">{t.name}</h4>
                    <p className="text-sm text-gray-500" data-id="element-261">{t.role}</p>
                  </div>
                </div>
                <div className="mt-4 flex" data-id="element-262">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" fill="currentColor" data-id="element-263" />)}
                </div>
                <p className="mt-4 text-gray-600 italic" data-id="element-264">"{t.quote}"</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};